import { render } from "./company-profile-input.vue?vue&type=template&id=9fceca8c&scoped=true"
import script from "./company-profile-input.vue?vue&type=script&lang=js"
export * from "./company-profile-input.vue?vue&type=script&lang=js"

import "./company-profile-input.vue?vue&type=style&index=0&id=9fceca8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fceca8c"]])

export default __exports__